import { AxiosRequestConfig } from 'axios';
import ApiConstants from '../constants/ApiConstants';
import { FORMAT } from '../constants/Constant';
import http from "../http";
import { TENANT, TenantService } from '../managers/TenantManagerService';
import Utility from '../utility/Utility';
export interface apiConstInterface {
    format: string,
    fromDate?: string,
    toDate?: string,
    exportAll?: string,
    selectedEmployee?: string
}
class DocumentService {
    static apiConfig: apiConstInterface;

    static printInfo(param, isRefresh) {
        let url = ApiConstants.URL.DOCUMENT.PRINT_INFO;
        if (isRefresh) {
            url = url + '?refresh=true'
        }
        return http.post(url, param)
    }

    static checkPrintInfo(param, isRefresh) {
        let url = ApiConstants.URL.DOCUMENT.CHECK_PRINT_INFO;
        if (isRefresh) {
            url = url + '?refresh=true'
        }
        return http.post(url, param)
    }

    static printDocByUID(uid) {
        let url = ApiConstants.URL.DOCUMENT.PRINT_DOC_BY_ID(uid)

        const config: AxiosRequestConfig = {

            responseType: "blob"
        }
        return http.get(
            url,
            config
        );
    }
    static designDocument(param) {
        let url = `${ApiConstants.URL.DOCUMENT.PRINT_INFO_TEMP}PAYSLIP/${param.employeeId}/${param.paystubId}`;
        return http.get(url)
    }

    static designPayrollChequeDocument(param) {
        let url = ApiConstants.URL.DOCUMENT.PRINT_INFO_CHECK;
        return http.post(url, param)
    }

    static getWorkPeriod(workPeriod) {
        if (workPeriod?.from && workPeriod?.to) {
            return `${Utility.formatDate(workPeriod.from, FORMAT.MMDDYYYY_2)} - ${Utility.formatDate(workPeriod.to, FORMAT.MMDDYYYY_2)}`
        }
    }

    static defaultTemplate(tid) {
        let url = ApiConstants.URL.DOCUMENT.DEFAULT_TEMPLATE(tid);
        return http.put(url, {})
    }
}

export default DocumentService;
